import React from 'react';
import WhatMetaSistema from '../components/metasistema/WhatMetaSistema';
import DigitalPlatforms from '../components/metasistema/DigitalPlatforms';
import Iniciatives from '../components/metasistema/Iniciatives';
import StrategicAlliances from '../components/metasistema/StrategicAlliances';

const MetaSistema = () => {
    return (
        <div>
           <WhatMetaSistema />
           <DigitalPlatforms />
           <Iniciatives />
        </div>
    );
};

export default MetaSistema;